import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import AdditionOptionService from "services/AdditionOptionService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getAllAdditionOptions = createAsyncThunk(
  "addition-option/getAllAdditionOptions",
  async (params, { rejectWithValue }) => {
    try {
      const response = await AdditionOptionService.getAllAdditionOptions(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const upsertAdditionOption = createAsyncThunk(
  "addition-option/upsertAdditionOption",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await AdditionOptionService.upsertAdditionOption(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const deleteAdditionOption = createAsyncThunk(
  "addition-option/deleteAdditionOption",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;

      const response = await AdditionOptionService.deleteAdditionOption(id);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loadingList: false,
  loadingUpsert: false,
  loadingDelete: false,

  additionOptionList: [],
};

export const additionOptionSlice = createSlice({
  name: "addition-option",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET LIST
      .addCase(getAllAdditionOptions.pending, (state) => {
        state.loadingList = true;
      })
      .addCase(getAllAdditionOptions.fulfilled, (state, action) => {
        state.loadingList = false;
        state.additionOptionList = action.payload;
      })
      .addCase(getAllAdditionOptions.rejected, (state) => {
        state.loadingList = false;
      })

      // UPDATE
      .addCase(upsertAdditionOption.pending, (state) => {
        state.loadingUpsert = true;
      })
      .addCase(upsertAdditionOption.fulfilled, (state) => {
        state.loadingUpsert = false;
      })
      .addCase(upsertAdditionOption.rejected, (state) => {
        state.loadingUpsert = false;
      })

      // DELETE
      .addCase(deleteAdditionOption.pending, (state) => {
        state.loadingDelete = true;
      })
      .addCase(deleteAdditionOption.fulfilled, (state) => {
        state.loadingDelete = false;
      })
      .addCase(deleteAdditionOption.rejected, (state) => {
        state.loadingDelete = false;
      });
  },
});

export default additionOptionSlice.reducer;